
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';
import { Balance } from '@/types/expense';

interface BalanceCardProps {
  balances: Balance[];
  formatCurrency: (amount: number) => string;
}

const BalanceCard: React.FC<BalanceCardProps> = ({ balances, formatCurrency }) => {
  return (
    <Card className="border-t-4 border-t-purple-DEFAULT">
      <CardHeader>
        <CardTitle className="text-xl text-purple-dark">Balances</CardTitle>
      </CardHeader>
      <CardContent>
        {balances.length === 0 ? (
          <div className="text-center text-gray-500">No balance data available</div>
        ) : (
          <ul className="space-y-3">
            {balances.map((balance) => (
              <li 
                key={balance.user_id}
                className="flex justify-between items-center p-3 rounded-md border"
              >
                <span>{balance.name}</span>
                <span 
                  className={`font-medium ${
                    balance.amount > 0 
                      ? 'text-green-600' 
                      : balance.amount < 0 
                        ? 'text-red-600' 
                        : ''
                  }`}
                >
                  {formatCurrency(balance.amount)}
                </span>
              </li>
            ))}
          </ul>
        )}
        <div className="mt-4 flex items-center text-sm text-gray-500">
          <AlertCircle className="h-4 w-4 mr-1" />
          <span>Positive: you are owed money. Negative: you owe money.</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default BalanceCard;
